import type { AccTabItem } from "accelerator-common/lib/AccTabList";
import { useRoleContext, UserRoles } from "hybridspace-common/lib/context";
import { isAccountFeatureEnabled } from "owa-feature-flags";
import EarthFilled from "owa-fluent-icons-svg/lib/icons/EarthFilled";
import EarthRegular from "owa-fluent-icons-svg/lib/icons/EarthRegular";
import PeopleCommunityFilled from "owa-fluent-icons-svg/lib/icons/PeopleCommunityFilled";
import PeopleCommunityRegular from "owa-fluent-icons-svg/lib/icons/PeopleCommunityRegular";
import WindowDevToolsFilled from "owa-fluent-icons-svg/lib/icons/WindowDevToolsFilled";
import WindowDevToolsRegular from "owa-fluent-icons-svg/lib/icons/WindowDevToolsRegular";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";
import { isPlacesExploreEnabled } from "places-settings";
import React from "react";
import { DEV_PANEL, PEOPLE } from "./HomeRoutes";
import { hybridspaceDevPanelLink as strings_hybridspaceDevPanelLink, hybridspaceExplorePageLink as strings_hybridspaceExplorePageLink, hybridspaceWorkPlanLink as strings_hybridspaceWorkPlanLink, } from "./useHybridspaceHomeLinks.locstring.json";

export default function useHybridspaceHomeLinks(): AccTabItem[] {
    const mailboxInfo = getModuleContextMailboxInfo();
    const isPlacesExplorePageEnabled = isPlacesExploreEnabled(mailboxInfo);
    const roleSwitcherContext = useRoleContext();
    const isDevPanelEnabled = isAccountFeatureEnabled("msplaces-devPanel", mailboxInfo);
    const roleSwitcherDisabled = isAccountFeatureEnabled("msplaces-disableRoleSwitcher", mailboxInfo);
    const shouldHideHomeLinks = !roleSwitcherDisabled && roleSwitcherContext.userRole !== UserRoles.Employee;
    
    return React.useMemo(() => {
        const workPlan = {
            id: isPlacesExplorePageEnabled ? "Work Plan" : "Dashboard",
            key: isPlacesExplorePageEnabled ? `/${PEOPLE}` : `/`,
            icon: PeopleCommunityRegular,
            activeIcon: PeopleCommunityFilled,
            textResourceId: strings_hybridspaceWorkPlanLink,
            ariaLabelResourceId: strings_hybridspaceWorkPlanLink,
            hidden: shouldHideHomeLinks,
        };
        
        const explore = {
            id: "Explore",
            key: `/`,
            icon: EarthRegular,
            activeIcon: EarthFilled,
            textResourceId: strings_hybridspaceExplorePageLink,
            ariaLabelResourceId: strings_hybridspaceExplorePageLink,
            hidden: !isPlacesExplorePageEnabled || shouldHideHomeLinks,
        };
        
        const devPanel = {
            id: "devPanel",
            key: `/${DEV_PANEL}`,
            icon: WindowDevToolsRegular,
            activeIcon: WindowDevToolsFilled,
            textResourceId: strings_hybridspaceDevPanelLink,
            ariaLabelResourceId: strings_hybridspaceDevPanelLink,
            hidden: !isDevPanelEnabled || shouldHideHomeLinks,
        };
        
        if (isPlacesExplorePageEnabled) {
            return [explore, workPlan, devPanel];
        }
        else {
            return [workPlan, devPanel];
        }
    }, [isPlacesExplorePageEnabled, shouldHideHomeLinks, isDevPanelEnabled]);
}
